export default "__VITE_ASSET__CfJt6Hil__"